import { render } from "./NavBar.vue?vue&type=template&id=54003854&scoped=true&ts=true"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"

import "./NavBar.vue?vue&type=style&index=0&id=54003854&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54003854"]])

export default __exports__